import styled from "styled-components";

export const ArquivoUploadBox = styled.div`
  clear: both;
  margin-bottom: 25px;
  padding: 0;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: .25rem;
  padding: 15px;
`;

export const ArquivoUploadTitle = styled.div`
  padding: 14px 15px 7px;
  min-height: 48px;
  font-size: 16px;
  font-weight: bold;
`;

export const Obrigatorio = styled.span`
  font-weight: bold;
  color: ${props => props.theme.colors.red};
`;